export const questionsAndAnswers = [
    {
      question: "What is the purpose of this website?",
      answer: "This site is designed to help 2CP students excel in the Economics class by providing them with resources such as courses, videos and exam tests.",
    },
    {
      question: "How are grades calculated on the different tests?",
      answer: "Grades are calculated by awarding points for each correct answer and deducting points for incorrect ones. The minimum grade for a question is 0.",
    },
    {
      question: "How can I verify the authenticity of the questions?",
      answer: "The questions provided on the exams and tests are sourced from previous years' official assessments and are reviewed by knowledgeable students in Economics to ensure accuracy and relevance.",
    },
    {
      question: "How can I contribute to this project?",
      answer: "Yes! Contributions are welcome! You can help by providing feedback, suggesting new questions or even adding materials.",
    },
    {
      question: "Why should I star the project repository on GitHub?",
      answer: "Starring the project repository on GitHub shows your support and appreciation for the effort and time spent on developing this resource. It helps raise awareness and encourages further improvements, making it easier for others to find and benefit from this valuable tool.",
      link: "https://github.com/soualahmohammedzakaria/ECON-Master"
    },
    {
      question: "What should I do if I encounter technical issues on the site?",
      answer: "If you experience technical issues, please contact me at mz_soualahmohammed@esi.dz and I will assist you promptly.",
    },
]; 